<template>
  <div></div>
</template>

<script>
import {RouterUtils} from '../utils/router-utils';

export default {
  name: 'StartPage',
  mixins: [
    RouterUtils
  ],
  mounted () {
    this.gotoLandingPage();
  }
}
</script>
